import { Helmet } from "react-helmet";
import seoMetaData from "../../Include/Seo/seoMetaData";
import Navbar from "../../Include/Navbar/Navbar";
import Footer from "../../Include/Footer/Footer";
import Breadcrumb from "./Data/Breadcrumb";
import breadcrumbData from "./Data/breadcrumbData";
import Contact from "../Home/Contact";
import Services from "./Data/Services";
import servicesData from "./Data/servicesData";
import TechCTASection from "./Data/HireSection";
// import OurExpertise from './Data/OurExpertise';
import Whyus from "./Data/Whyus";
import whyData from "./Data/whyusData";

export default function Index() {
  const { title, description, keywords } = seoMetaData.spring;
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <link
          rel="canonical"
          href="https://www.cloudkode.com/services/spring-development"
        />
        <script type="application/ld+json">
  {`{
    "@context": "https://schema.org",
    "@type": "WebPage",
    "url": "https://cloudkodeform.com/technology/spring",
    "name": "Spring Framework & Microservices Development",
    "description": "CloudKodeForm offers enterprise-grade Spring framework and microservices development services. Build robust, scalable, and modular backend systems with Spring Boot and Spring Cloud.",
    "inLanguage": "en",
    "publisher": {
      "@type": "Organization",
      "name": "CloudKodeForm",
      "url": "https://cloudkodeform.com",
      "logo": {
        "@type": "ImageObject",
        "name": "CloudKodeForm",
        "url": "https://cloudkodeform.com/static/media/logo_white.210461645b0e9241d56c926ddacdd810.svg"
      }
    },
    "mainEntity": {
      "@type": "Service",
      "name": "Spring Development Services",
      "serviceType": "Java Spring Framework & Microservices Architecture",
      "provider": {
        "@type": "Organization",
        "name": "CloudKodeForm",
        "url": "https://cloudkodeform.com"
      },
      "areaServed": {
        "@type": "Place",
        "name": "Global"
      }
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://cloudkodeform.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Technology",
          "item": "https://cloudkodeform.com/technology"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Spring",
          "item": "https://cloudkodeform.com/technology/spring"
        }
      ]
    }
  }`}
</script>

      </Helmet>
      <Navbar />
      <Breadcrumb data={breadcrumbData.spring} />
      <Services data={servicesData.spring} />
      <TechCTASection />
      {/* <OurExpertise/> */}
      <Whyus data={whyData.spring} />
      <Contact sectionId="spring-contact-page" />
      <Footer />
    </>
  );
}
